// authBootstrap reads the per-request <script id="auth-bootstrap"> tag rendered
// into index.html by the BFF. bootstrapTracking uses this value to push userId
// into the dataLayer before initTracking creates the GTM script tag — the
// GTM → cookie → Sourcepoint chain then picks up the correct user on first
// paint. See apps/bff/internal/auth/bootstrap.go for the server side.

type AuthBootstrap = { userHandle: string | null };

function read(): AuthBootstrap {
  const el = document.getElementById('auth-bootstrap');
  if (!el?.textContent) {
    return { userHandle: null };
  }
  try {
    const raw: unknown = JSON.parse(el.textContent);
    if (raw && typeof raw === 'object' && 'userHandle' in raw) {
      const value = (raw as { userHandle: unknown }).userHandle;
      if (typeof value === 'string' && value.length > 0) {
        return { userHandle: value };
      }
    }
  } catch {
    // Missing/malformed tag must not break bootstrap; fall through to null.
  }
  return { userHandle: null };
}

export const authBootstrap: AuthBootstrap = Object.freeze(read());
